import _ from 'lodash';
import Soap from '../ews/soap';

export default {
    sendMail (recipients, callback) {
        const mailbox = window.Office.context.mailbox;
        const item = mailbox.item;
        mailbox.makeEwsRequestAsync(Soap.getItemDataXML(item.itemId), (getItemResponse) => {
            const parser = new DOMParser();
            const responseDoc = parser.parseFromString(getItemResponse.value, 'text/xml');
            const responseItem = responseDoc.getElementsByTagName('t:ItemId')[0];
            const changeKey = responseItem.getAttribute('ChangeKey');
            const id = responseItem.getAttribute('Id');
            _.forEach(recipients, (to) => {
                mailbox.makeEwsRequestAsync(
                    Soap.getForwardXML(id, changeKey, to), (forwardResponse) => {
                        if (forwardResponse.status !== 'succeeded') {
                            callback(false);
                        }
                    });
            });
        });
    }
};



// WEBPACK FOOTER //
// ./src/services/EmailService.js